import React, {Component} from 'react';
import PropTypes from "prop-types";
import OperatorAddContainer from "./OperatorAddContainer";
import OperatorEditContainer from "./OperatorEditContainer";
import OperatorOverviewContainer from "./OperatorOverviewContainer";

class OperatorContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {
            activeView: null,
            operatorEdit: null,
        };

        this.translate = this.props.baseData.translate;

        this.changeView = this.changeView.bind(this);

    }

    changeView(activeView = null, operatorEdit = null) {

        this.setState({
            activeView,
            operatorEdit
        });

    }

    renderView() {

        const view = this.state.activeView;

        if (view === 'add') {
            return <OperatorAddContainer
                baseData={this.props.baseData}
                changeView={this.changeView}
            />;
        } else if (view === 'edit') {
            return <OperatorEditContainer
                baseData={this.props.baseData}
                operator={this.state.operatorEdit}
                changeView={this.changeView}
            />;
        } else {
            return <OperatorOverviewContainer
                baseData={this.props.baseData}
                currentCompany={this.props.baseData.companies.currentCompany}
                changeView={this.changeView}
            />;
        }

    }

    render() {

        const renderedView = this.renderView();

        return (
            <div>
                {renderedView}
            </div>
        );

    }

}

export default OperatorContainer;